import gql from "graphql-tag";

export default gql`
mutation messagePush ($id: String!, $clientId: String!, $input: MessageInput!){
  message: messagePush(id: $id, clientId: $clientId, input: $input) {
    id
  }
}

`